
import { Options, Vue, prop } from 'vue-class-component';
import { OptionsClass } from '@/domain/entities/MainApp';
import Checkbox from 'primevue/checkbox';

class Props {
  modelValue = prop<OptionsClass[]>({
    default: () => [],
    required: true
  });
  options= prop<OptionsClass[]>({
    default: () => [],
    required: true
  });
}


@Options({
  emits: ["change", "clear"],
  components: {
    Checkbox
  }
})
export default class MultipleSelect extends Vue.with(Props) {
  isOpen = false

  isOptionChecked(hubOption = new OptionsClass()) {
    return this.modelValue.map(value => value.value).includes(hubOption.value);
  }

  onClick(event: any) {
    this.isOpen = true;
  }

  onBlur(event: any) {
    this.isOpen = false;
  }

  async onSelectHub(hubValue = new OptionsClass()) {
    const isExist = !!this.modelValue.find(hub => hub.value === hubValue.value)?.value;
    if (isExist) {
     this.$emit("update:modelValue", this.modelValue.filter(hub => hub.value != hubValue.value));
    } else {
      this.modelValue.push(hubValue);
    }
    await this.$nextTick();

    this.$emit("change", this.modelValue.find(value => value.value === hubValue.value));
  }

  clear(event: any) {
    event.stopPropagation();
    this.$emit("update:modelValue", []);
    this.$emit("clear");
  }
}
